// Wannlabs single sign-on (wannlabs.com / build.wannlabs.com -> Prime).
// Launchers open Prime with ?wl=1. If Prime has no session yet we bounce once to
// wannlabs.com/app (the central sign-in) with a PKCE challenge; it sends back a 60 s
// single-use code in the #fragment to /auth/wannlabs (see wannlabs-pkce.ts). No session there -> back to Prime with ?wl_nosession=1 (no loop).
import { hasWannlabsHint } from "./wannlabs-pkce";

// Legacy start URL (older flow through Ember); the PKCE flow is startWannlabsSso() in wannlabs-pkce.ts.
export const WANNLABS_SSO_START = "https://build.wannlabs.com/#wl_sso_return=prime";
const TRIED_KEY = "prime_wl_sso_tried";

function fromWannlabsReferrer(referrer: string): boolean {
  try {
    const host = new URL(referrer).hostname;
    return /(^|\.)wannlabs\.com$/.test(host);
  } catch {
    return false;
  }
}

/** Should the landing page try Wannlabs SSO before showing marketing? */
export function shouldTryWannlabsSso(loc: Location, referrer: string): boolean {
  const q = new URLSearchParams(loc.search);
  if (q.has("wl_nosession")) {
    try { sessionStorage.setItem(TRIED_KEY, "1"); } catch { /* ignore */ }
    return false;
  }
  if (!(q.get("wl") === "1" || fromWannlabsReferrer(referrer) || hasWannlabsHint())) {
    return false;
  }
  try {
    if (sessionStorage.getItem(TRIED_KEY)) return false;
    sessionStorage.setItem(TRIED_KEY, "1");
  } catch {
    return false;
  }
  return true;
}

export function readHandoffFromHash(hash: string): string | null {
  const code = new URLSearchParams(hash.replace(/^#/, "")).get("wl_handoff");
  return code && /^[A-Za-z0-9_-]{16,256}$/.test(code) ? code : null;
}

/**
 * /login: try Wannlabs SSO once per tab without needing ?wl=1 or a referrer.
 * Same once-per-tab guard as the landing page, so it can never loop.
 */
export function shouldTryWannlabsSsoOnLogin(loc: Location): boolean {
  const q = new URLSearchParams(loc.search);
  if (q.has("wl_nosession") || q.has("error") || q.get("wl") === "0") {
    try { sessionStorage.setItem(TRIED_KEY, "1"); } catch { /* ignore */ }
    return false;
  }
  try {
    if (sessionStorage.getItem(TRIED_KEY)) return false;
    sessionStorage.setItem(TRIED_KEY, "1");
  } catch {
    return false;
  }
  return true;
}
